import { ArrowDropdown } from '@/components/icons'
import { Listbox, Transition } from '@headlessui/react'
import { FC, Fragment } from 'react'
import { useTranslation } from 'react-i18next'

export type SelectProps = {
  label?: string
  labelClassName?: string
  options: SelectOption[]
  placeholder?: string
  value?: SelectOption
  onChange: (event: any) => void
  error?: string
  containerClassName?: string
  buttonClassName?: string
  optionClassName?: string
  optionsClassName?: string
  activeOptionClassName?: string
  disabled?: boolean
}

export type SelectOption = {
  key: string | number
  value: string | number | null
  label: string | number
}

export type SelectOptions = SelectOption[]

export const Select: FC<SelectProps> = ({
  label,
  labelClassName,
  options,
  error,
  containerClassName,
  buttonClassName,
  optionClassName,
  optionsClassName,
  value = null, // default value to remove warning
  onChange,
  activeOptionClassName,
  placeholder = 'Select',
  disabled,
}) => {
  const { t } = useTranslation()

  return (
    <div className={`w-full flex flex-col gap-y-2 ${containerClassName ? containerClassName : ''}`}>
      {label && <p className={`text-white text-sm font-semibold ${labelClassName && labelClassName}`}>{label}</p>}

      <div className="relative">
        <Listbox value={value} disabled={disabled} onChange={onChange}>
          <Listbox.Button
            className={`p-3 md:p-[15px] focus:outline-none border border-navy-900 border-opacity-20
            text-sm rounded-full w-full flex justify-between items-center gap-x-2 ${
              disabled ? 'bg-gray-300 text-gray-500' : 'text-navy-900'
            } ${buttonClassName ? buttonClassName : ''}`}
          >
            <p className={`mb-0 ${!value && 'opacity-50'}`}>
              {value?.label ? t(`common.${value?.label}`) : placeholder}
            </p>
            <ArrowDropdown />
          </Listbox.Button>
          <Transition as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
            <Listbox.Options
              className={`${
                optionsClassName ? optionsClassName : ''
              } absolute z-50 w-full bg-white mt-1 top-full border-t border-navy-900 border-opacity-20 
                cursor-pointer shadow-sm shadow-slate-500 `}
            >
              {options &&
                options.map((option) => (
                  <Listbox.Option
                    className={({ active }) =>
                      `p-2 ${optionClassName ? optionClassName : ''} ${
                        active ? `text-white bg-primary-300 ${activeOptionClassName}` : ''
                      }`
                    }
                    key={`option-${option.key}`}
                    value={option.value}
                  >
                    {t(`common.${option?.label}`)}
                  </Listbox.Option>
                ))}
            </Listbox.Options>
          </Transition>
        </Listbox>
      </div>

      {error && <div className="text-boldOrange -mt-1 font-medium">{error}</div>}
    </div>
  )
}
